import React from 'react';
import styled from 'styled-components';
import { Button } from 'semantic-ui-react';
import QRCode from 'qrcode.react';
import { StyledModal } from './SharedStyles';

const QRModal = styled(StyledModal)`
  &&& {
    width: auto !important;
    max-width: 90vw;
  }
`;

const QRCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const CloseButton = styled(Button)`
  &&& {
    margin-top: 20px;
    border-radius: 8px;
  }
`;

const QRCodeModal = ({ open, onClose }) => {
  return (
    <QRModal open={open} onClose={onClose} size="mini">
      <QRModal.Content>
        <QRCodeContainer>
          <QRCode value={window.location.href} size={256} />
          <CloseButton onClick={onClose}>Close</CloseButton>
        </QRCodeContainer>
      </QRModal.Content>
    </QRModal>
  );
};

export default QRCodeModal;
